var exports = {
  "kL": "x31de4314--b9540a--container",
  "wx": "x31de4314--b9540a--header",
  "Wo": "x31de4314--b9540a--header-agent",
  "kB": "x31de4314--b9540a--header-agent-logo",
  "M$": "x31de4314--b9540a--header-content",
  "iL": "x31de4314--b9540a--header-all-offers",
};

module.exports = exports;
